import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

// =============================
// 🔹 Tipagens de entidades
// =============================

export interface Pessoa {
  id: number;
  nome: string;
  telefone: string;
}

export interface TipoMensagem {
  id: number;
  nome: string;
  descricao?: string;
}

export interface MensagemPessoa {
  id: number;
  pessoaId: number;
  Pessoa?: Pessoa;

  campanhaId?: number;
  tipoMensagemId?: number;
  TipoMensagem?: TipoMensagem;

  token: string;
  validate_at: string;
  prioridade: number;

  titulo?: string;
  conteudo?: string;
  statusMensagem: string;
  restricao: string;

  dataEnvio?: string;
  dataResposta?: string;
  agendadaPara?: string;
  proximaDataEnvio?: string;

  createdAt?: string;
  updatedAt?: string;
}

// =============================
// 🔹 Função auxiliar de headers
// =============================

const getHeaders = () => {
  const Token = validateToken();
  return Token ? { Authorization: Token.AuthStr } : {};
};

// =============================
// 🔹 Serviços
// =============================

/**
 * 🔹 Lista todas as mensagens (sem filtro)
 */
export const listarMensagensService = async (): Promise<MensagemPessoa[] | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/mensagens`;
    try {
      const response = await axios.get(URL, { headers: { Authorization: Token.AuthStr } });
      return response.data;
    } catch (error) {
      console.error("Erro ao listar mensagens:", error);
    }
  }
};

/**
 * 🔹 Lista mensagens de uma campanha específica
 */
export const listarMensagensPorCampanhaService = async (
  campanhaId: number
): Promise<MensagemPessoa[] | undefined> => {

  console.log("Fetching messages for campaign ID:", campanhaId); // 🧠 log para depuração
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/mensagens/campanha/${campanhaId}`;
    try {
      const response = await axios.get(URL, { headers: { Authorization: Token.AuthStr } });
      console.log("Mensagens da campanha:", response.data); // 🧠 log para depuração
      return response.data;
    } catch (error) {
      console.error("Erro ao listar mensagens por campanha:", error);
    }
  }
};

/**
 * 🔹 Buscar mensagem por ID
 */
export const buscarMensagemPorIdService = async (
  id: number
): Promise<MensagemPessoa | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/mensagens/${id}`;
    try {
      const response = await axios.get(URL, { headers: { Authorization: Token.AuthStr } });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar mensagem por ID:", error);
    }
  }
};

/**
 * 🔹 Criar nova mensagem
 */
export const criarMensagemService = async (
  dados: Partial<MensagemPessoa>
): Promise<MensagemPessoa | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/mensagens`;
    try {
      const response = await axios.post(URL, dados, { headers: { Authorization: Token.AuthStr } });
      return response.data;
    } catch (error) {
      console.error("Erro ao criar mensagem:", error);
    }
  }
};

/**
 * 🔹 Atualizar uma mensagem existente
 */
export const atualizarMensagemService = async (
  id: number,
  dados: Partial<MensagemPessoa>
): Promise<MensagemPessoa | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/mensagens/${id}`;
    try {
      const response = await axios.put(URL, dados, { headers: { Authorization: Token.AuthStr } });
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar mensagem:", error);
    }
  }
};

/**
 * 🔹 Excluir mensagem
 */
export const excluirMensagemService = async (id: number): Promise<void> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/mensagens/${id}`;
    try {
      await axios.delete(URL, { headers: { Authorization: Token.AuthStr } });
    } catch (error) {
      console.error("Erro ao excluir mensagem:", error);
    }
  }
};

// =============================
// 🔹 Exportação agrupada
// =============================

export const mensagensPessoaService = {
  listarMensagensService,
  listarMensagensPorCampanhaService,
  buscarMensagemPorIdService,
  criarMensagemService,
  atualizarMensagemService,
  excluirMensagemService,
};
